import VeeValidate, {Validator} from 'vee-validate';
import installRules from '../validation/rules';
import es from 'vee-validate/dist/locale/es';
import attr from "../lang/attributos";
import Vue from "vue";

const config = {
    errorBagName: 'errores', // change if property conflicts.
    locale: 'es',
    dictionary: {
        es: {
            messages: es.messages,
            attributes: attr
        }
    },
    events: 'blur',
};
Vue.use(VeeValidate, config);
Validator.localize('es', es);
installRules(Validator);


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/veeValidate.js